import { render, staticRenderFns } from "./GridColumn.vue?vue&type=template&id=41c9ace4&scoped=true&"
import script from "./GridColumn.vue?vue&type=script&lang=js&"
export * from "./GridColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c9ace4",
  null
  
)

export default component.exports